<app-social-facebook *ngIf="type === 'facebook'"></app-social-facebook>
<app-social-instagram *ngIf="type === 'instagram'"></app-social-instagram>
<app-social-twitter *ngIf="type === 'twitter'"></app-social-twitter>
<app-social-pinterest *ngIf="type === 'pinterest'"></app-social-pinterest>
<app-social-linkedin *ngIf="type === 'linkedin'"></app-social-linkedin>
